var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 53",
    fill: "#fff",
    stroke: "#95989a",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.375,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#5300f2",
    stroke: "#5300f2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 180",
    d: "M20.081 8.899a3.073 3.073 0 00-4.34 0l-2.17 2.17a.472.472 0 00.668.668l2.17-2.17a2.124 2.124 0 013 3l-2.835 2.839a2.128 2.128 0 01-3 0 .472.472 0 00-.668.668 3.072 3.072 0 004.34 0l2.835-2.837a3.076 3.076 0 000-4.338z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 181",
    d: "M14.404 17.576l-1.836 1.836a2.124 2.124 0 01-3-3l2.671-2.671a2.132 2.132 0 013 0 .472.472 0 10.668-.668 3.073 3.073 0 00-4.34 0l-2.67 2.667a3.068 3.068 0 004.34 4.339l1.836-1.836a.472.472 0 00-.667-.668z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveLink);
export default __webpack_public_path__ + "static/media/inactive-link.bd7e8c2f4e22b4de6bda823ce3667b03.svg";
export { ForwardRef as ReactComponent };